webpackJsonp([255565801188096],{

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  margin-top: 3rem;\n\n  > svg {\n    margin: 0 1rem;\n  }\n\n  ', ';\n\n  ', ';\n'], ['\n  display: flex;\n  margin-top: 3rem;\n\n  > svg {\n    margin: 0 1rem;\n  }\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    flex-direction: column;\n\n    > svg {\n      display: none;\n    }\n  '], ['\n    flex-direction: column;\n\n    > svg {\n      display: none;\n    }\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    margin-top: ', ';\n    margin-bottom: 3rem;\n  '], ['\n    margin-top: ', ';\n    margin-bottom: 3rem;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  width: 70%;\n\n  ', ';\n\n  h1 {\n    margin: 2.5rem 0 0 0;\n  }\n'], ['\n  position: relative;\n  width: 70%;\n\n  ', ';\n\n  h1 {\n    margin: 2.5rem 0 0 0;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n\n  ', ';\n\n  ', ';\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: center;\n  }\n'], ['\n  flex: 1;\n\n  ', ';\n\n  ', ';\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    align-items: center;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    margin: 3rem 0;\n    width: 100%;\n    height: 300px;\n  '], ['\n    display: flex;\n    margin: 3rem 0;\n    width: 100%;\n    height: 300px;\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    margin-top: 1rem;\n    height: auto;\n  '], ['\n    margin-top: 1rem;\n    height: auto;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  object-fit: contain;\n  font-family: \'object-fit: contain;\';\n\n  ', ';\n\n  ', ';\n'], ['\n  object-fit: contain;\n  font-family: \'object-fit: contain;\';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    width: 50%;\n  '], ['\n    width: 50%;\n  ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  line-height: 1.5;\n  font-family: \'Montserrat\';\n  margin: 1rem 0;\n\n  ', ';\n\n  ', ';\n\n  span,\n  a {\n    color: #9b9b9b;\n  }\n\n  svg {\n    line {\n      stroke: #e9e9e9;\n    }\n  }\n'], ['\n  display: flex;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  line-height: 1.5;\n  font-family: \'Montserrat\';\n  margin: 1rem 0;\n\n  ', ';\n\n  ', ';\n\n  span,\n  a {\n    color: #9b9b9b;\n  }\n\n  svg {\n    line {\n      stroke: #e9e9e9;\n    }\n  }\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n    flex: 1;\n  '], ['\n    flex: 1;\n  ']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n    flex-direction: column;\n\n    span,\n    a {\n      margin-bottom: 0.5rem;\n    }\n\n    svg {\n      display: none;\n    }\n  '], ['\n    flex-direction: column;\n\n    span,\n    a {\n      margin-bottom: 0.5rem;\n    }\n\n    svg {\n      display: none;\n    }\n  ']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n  ul {\n    margin-left: 0;\n  }\n  ol {\n    list-style-type: decimal;\n    list-style-position: outside;\n    margin-left: 30px;\n\n    li {\n      padding-left: 1rem;\n    }\n  }\n'], ['\n  ul {\n    margin-left: 0;\n  }\n  ol {\n    list-style-type: decimal;\n    list-style-position: outside;\n    margin-left: 30px;\n\n    li {\n      padding-left: 1rem;\n    }\n  }\n']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  '], ['\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  ']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n  margin-top: 2rem;\n'], ['\n  margin-top: 2rem;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(86);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Container = __webpack_require__(35);
	
	var _FancyTextCollection = __webpack_require__(171);
	
	var _FancyTextCollection2 = _interopRequireDefault(_FancyTextCollection);
	
	var _SubHeading = __webpack_require__(72);
	
	var _SubHeading2 = _interopRequireDefault(_SubHeading);
	
	var _FeatureBox = __webpack_require__(173);
	
	var _FeatureBox2 = _interopRequireDefault(_FeatureBox);
	
	var _FancyButton = __webpack_require__(128);
	
	var _FancyButton2 = _interopRequireDefault(_FancyButton);
	
	var _theme = __webpack_require__(9);
	
	var _BottomSection = __webpack_require__(127);
	
	var _BottomSection2 = _interopRequireDefault(_BottomSection);
	
	var _gatsbyLink = __webpack_require__(68);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var RecipePageWrapper = _Container.Container.extend(_templateObject, _theme.media.forSmallMediumOnly(_templateObject2), _theme.media.forSmallOnly(_templateObject3, function (props) {
	  return 'calc(' + props.theme.mobileHeaderHeight + ' + 2rem)';
	}));
	
	var RecipeWrapper = _styledComponents2.default.div(_templateObject4, _theme.media.forSmallMediumOnly(_templateObject5));
	var FeaturedProductWrapper = _styledComponents2.default.div(_templateObject6, _theme.media.forSmallMediumOnly(_templateObject7), _theme.media.forSmallOnly(_templateObject8));
	
	var ProductImage = _styledComponents2.default.img(_templateObject9, _theme.media.forSmallMediumOnly(_templateObject10), _theme.media.forSmallOnly(_templateObject5));
	
	var RecipeInfo = _styledComponents2.default.div(_templateObject11, _theme.media.forSmallMediumOnly(_templateObject12), _theme.media.forSmallOnly(_templateObject13));
	
	var MarkupContainer = _styledComponents2.default.div(_templateObject14);
	
	var FeaturedProductContentContainer = _styledComponents2.default.div(_templateObject15, _theme.media.forSmallOnly(_templateObject16));
	
	var LearnMoreButton = _FancyButton2.default.extend(_templateObject17);
	
	var RecipePage = function (_Component) {
	  _inherits(RecipePage, _Component);
	
	  function RecipePage() {
	    _classCallCheck(this, RecipePage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RecipePage.prototype.render = function render() {
	    var data = this.props.data;
	
	    if (!data) return null;
	
	    var images = void 0;
	    if (data.markdownRemark.frontmatter.product_tag === 'pickles') {
	      images = data.pickles;
	    }
	    if (data.markdownRemark.frontmatter.product_tag === 'jalapeños') {
	      images = data.jalapenos;
	    }
	    if (data.markdownRemark.frontmatter.product_tag === 'tomatoes') {
	      images = data.caprese;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        RecipePageWrapper,
	        null,
	        _react2.default.createElement(
	          RecipeWrapper,
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: images.sizes,
	            style: { height: '400px' },
	            imgStyle: { objectFit: 'cover' }
	          }),
	          _react2.default.createElement(
	            'h1',
	            null,
	            data.markdownRemark.frontmatter.title
	          ),
	          _react2.default.createElement(
	            RecipeInfo,
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              'Ready in: ',
	              data.markdownRemark.frontmatter.time_to_make
	            ),
	            _react2.default.createElement(
	              'svg',
	              { width: '40', height: '20' },
	              _react2.default.createElement('line', { x1: '20', y1: '20', x2: '20', y2: '0' })
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Yield: ',
	              data.markdownRemark.frontmatter.yield
	            )
	          ),
	          _react2.default.createElement(MarkupContainer, {
	            dangerouslySetInnerHTML: { __html: data.markdownRemark.html }
	          })
	        ),
	        _react2.default.createElement(
	          'svg',
	          { width: '40', height: '600' },
	          _react2.default.createElement('line', { x1: '20', y1: '600', x2: '20', y2: '0', stroke: '#e9e9e9' })
	        ),
	        _react2.default.createElement(
	          FeaturedProductWrapper,
	          null,
	          _react2.default.createElement(ProductImage, {
	            src: data.markdownRemark.frontmatter.product.image,
	            alt: data.markdownRemark.frontmatter.product.id
	          }),
	          _react2.default.createElement(
	            FeaturedProductContentContainer,
	            null,
	            _react2.default.createElement(_FancyTextCollection2.default, {
	              recipeStyle: true,
	              titleFont: data.markdownRemark.frontmatter.product.id
	            }),
	            _react2.default.createElement(
	              _SubHeading2.default,
	              null,
	              data.markdownRemark.frontmatter.product.tagline
	            ),
	            _react2.default.createElement(_FeatureBox2.default, {
	              featureOne: data.markdownRemark.frontmatter.product.featureOne,
	              featureTwo: data.markdownRemark.frontmatter.product.featureTwo,
	              featureThree: data.markdownRemark.frontmatter.product.featureThree
	            }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: data.markdownRemark.frontmatter.product.fields.slug },
	              _react2.default.createElement(
	                LearnMoreButton,
	                null,
	                'Learn more'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_BottomSection2.default, null)
	    );
	  };
	
	  return RecipePage;
	}(_react.Component);
	
	exports.default = RecipePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: Sacramento;\n  color: ', ';\n  font-size: ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  font-family: Sacramento;\n  color: ', ';\n  font-size: ', ';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 50px;\n    width: 100%;\n  '], ['\n    font-size: 50px;\n    width: 100%;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    font-size: 42px;\n  '], ['\n    font-size: 42px;\n  ']);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FancyFont = _styledComponents2.default.span(_templateObject, function (props) {
	  return props.theme.potmGreen;
	}, function (props) {
	  return props.fontSize || '58px';
	}, _theme.media.forSmallMediumOnly(_templateObject2), _theme.media.forSmallOnly(_templateObject3));
	
	exports.default = FancyFont;
	module.exports = exports['default'];

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  line-height: 0.65;\n  padding: 1rem 0 2rem;\n  text-align: left;\n\n  h2 {\n    margin: 0;\n  }\n\n  ', ';\n\n  ', ';\n\n  &.recipeStyle {\n    line-height: 0.5;\n\n    span {\n      font-size: 60px;\n    }\n\n    h2 {\n      font-size: 40px;\n    }\n\n    ', ';\n  }\n'], ['\n  line-height: 0.65;\n  padding: 1rem 0 2rem;\n  text-align: left;\n\n  h2 {\n    margin: 0;\n  }\n\n  ', ';\n\n  ', ';\n\n  &.recipeStyle {\n    line-height: 0.5;\n\n    span {\n      font-size: 60px;\n    }\n\n    h2 {\n      font-size: 40px;\n    }\n\n    ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 1rem 0;\n  '], ['\n    padding: 1rem 0;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    padding: 0;\n    line-height: 1;\n\n    h2 {\n      display: inline;\n      margin-left: 5px;\n    }\n  '], ['\n    padding: 0;\n    line-height: 1;\n\n    h2 {\n      display: inline;\n      margin-left: 5px;\n    }\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n      padding: 0 0 1rem;\n      text-align: center;\n\n      span {\n        font-size: 45px;\n      }\n\n      h2 {\n        font-size: 32px;\n      }\n  '], ['\n      padding: 0 0 1rem;\n      text-align: center;\n\n      span {\n        font-size: 45px;\n      }\n\n      h2 {\n        font-size: 32px;\n      }\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(9);
	
	var _FancyFont = __webpack_require__(71);
	
	var _FancyFont2 = _interopRequireDefault(_FancyFont);
	
	var _H = __webpack_require__(91);
	
	var _H2 = _interopRequireDefault(_H);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FancyTextCollectionContainer = _styledComponents2.default.div(_templateObject, _theme.media.forSmallMediumOnly(_templateObject2), _theme.media.forSmallOnly(_templateObject3), _theme.media.forSmallOnly(_templateObject4));
	
	var FancyTextCollection = function FancyTextCollection(_ref) {
	  var titleFont = _ref.titleFont,
	      recipeStyle = _ref.recipeStyle;
	  return _react2.default.createElement(
	    FancyTextCollectionContainer,
	    {
	      className: '' + (recipeStyle ? 'recipeStyle' : '')
	    },
	    _react2.default.createElement(
	      _FancyFont2.default,
	      null,
	      'Just'
	    ),
	    _react2.default.createElement(
	      _H2.default,
	      null,
	      titleFont
	    )
	  );
	};
	
	exports.default = FancyTextCollection;
	module.exports = exports['default'];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #dbdbdb;\n  font-family: \'Lato\';\n  font-size: 14px;\n  color: #666666;\n  max-width: 280px;\n  margin-top: 1rem;\n'], ['\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #dbdbdb;\n  font-family: \'Lato\';\n  font-size: 14px;\n  color: #666666;\n  max-width: 280px;\n  margin-top: 1rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  margin: 0px 1rem;\n  padding: 0.5rem 0;\n  position: relative;\n  border-bottom: 1px solid #dbdbdb;\n\n  &:last-child {\n    border: none;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n    margin: 0 0.5rem 0 0;\n    position: absolute;\n    left: -1.5rem;\n  }\n\n  span {\n    display: block;\n    line-height: 1;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin: 0px 1rem;\n  padding: 0.5rem 0;\n  position: relative;\n  border-bottom: 1px solid #dbdbdb;\n\n  &:last-child {\n    border: none;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n    margin: 0 0.5rem 0 0;\n    position: absolute;\n    left: -1.5rem;\n  }\n\n  span {\n    display: block;\n    line-height: 1;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _checkmarkIcon = __webpack_require__(262);
	
	var _checkmarkIcon2 = _interopRequireDefault(_checkmarkIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FeaturesList = _styledComponents2.default.div(_templateObject);
	
	var FeatureItem = _styledComponents2.default.div(_templateObject2);
	
	var FeatureBox = function FeatureBox(_ref) {
	  var featureOne = _ref.featureOne,
	      featureTwo = _ref.featureTwo,
	      featureThree = _ref.featureThree;
	  return _react2.default.createElement(
	    FeaturesList,
	    null,
	    _react2.default.createElement(
	      FeatureItem,
	      null,
	      _react2.default.createElement('img', { alt: '', src: _checkmarkIcon2.default }),
	      _react2.default.createElement(
	        'span',
	        null,
	        featureOne
	      )
	    ),
	    _react2.default.createElement(
	      FeatureItem,
	      null,
	      _react2.default.createElement('img', { alt: '', src: _checkmarkIcon2.default }),
	      _react2.default.createElement(
	        'span',
	        null,
	        featureTwo
	      )
	    ),
	    _react2.default.createElement(
	      FeatureItem,
	      null,
	      _react2.default.createElement('img', { alt: '', src: _checkmarkIcon2.default }),
	      _react2.default.createElement(
	        'span',
	        null,
	        featureThree
	      )
	    )
	  );
	};
	
	exports.default = FeatureBox;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiIFsNCgk8IUVOVElUWSBuc19mbG93cyAiaHR0cDovL25zLmFkb2JlLmNvbS9GbG93cy8xLjAvIj4NCl0+DQo8c3ZnIHZlcnNpb249IjEuMSINCgkgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6YT0iaHR0cDovL25zLmFkb2JlLmNvbS9BZG9iZVNWR1ZpZXdlckV4dGVuc2lvbnMvMy4wLyINCgkgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMTlweCIgaGVpZ2h0PSIxMTlweCIgdmlld0JveD0iLTUuOTM0IC00LjUwMyAxMTkgMTE5IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IC01LjkzNCAtNC41MDMgMTE5IDExOSINCgkgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZGVmcz4NCjwvZGVmcz4NCjxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjU0LjIxMiIgY3k9IjU2LjA5MSIgcj0iNDcuMjU2Ii8+DQo8cGF0aCBmaWxsPSIjRjg5NzFEIiBkPSJNNTQuMjE2LDBDNjMuOTcsMCw3My4wMSwyLjQ0Miw4MS4zMjMsNy4zMjZjOC4yOTksNC44NzcsMTQuODk3LDExLjQ2OCwxOS43NzQsMTkuNzgyDQoJYzQuODkyLDguMzA2LDcuMzI2LDE3LjMzOSw3LjMyNiwyNy4xMDFjMCw5Ljc2OC0yLjQzNSwxOC44MDItNy4zMjYsMjcuMTE1Yy00Ljg3Nyw4LjI5OS0xMS40NzYsMTQuODk3LTE5Ljc3NCwxOS43ODENCgljLTguMzEzLDQuODg1LTE3LjM1NCw3LjMxOS0yNy4xMDcsNy4zMTljLTkuNzc1LDAtMTguODEtMi40MzUtMjcuMTA4LTcuMzE5Yy04LjMxMy00Ljg4NC0xNC45MTEtMTEuNDgyLTE5Ljc4OC0xOS43ODENCglDMi40NDIsNzMuMDEsMCw2My45NzcsMCw1NC4yMDhjMC05Ljc2MSwyLjQ0Mi0xOC43OTUsNy4zMTktMjcuMTAxYzQuODc3LTguMzEzLDExLjQ3Ni0xNC45MDUsMTkuNzg4LTE5Ljc4Mg0KCUMzNS40MDYsMi40NDIsNDQuNDQsMCw1NC4yMTYsMHogTTU0LjIxNiwxMC40OTZjLTcuODc0LDAtMTUuMTU3LDEuOTU5LTIxLjg2NCw1LjljLTYuNzA2LDMuOTI2LTEyLjAyMiw5LjI1Ny0xNS45NjMsMTUuOTU2DQoJYy0zLjkzNCw2LjctNS44OTMsMTMuOTktNS44OTMsMjEuODU2YzAsNy44NzQsMS45NTksMTUuMTU3LDUuODkzLDIxLjg3MWMzLjk0LDYuNjk5LDkuMjU3LDEyLjAxNiwxNS45NjMsMTUuOTQ5DQoJYzYuNzA3LDMuOTQsMTMuOTksNS45MDcsMjEuODY0LDUuOTA3YzcuODY2LDAsMTUuMTU2LTEuOTY3LDIxLjg1NS01LjkwN2M2LjcwNy0zLjkzNCwxMi4wMjMtOS4yNSwxNS45NTctMTUuOTQ5DQoJYzMuOTMzLTYuNzE0LDUuOTA2LTEzLjk5Nyw1LjkwNi0yMS44NzFjMC03Ljg2Ny0xLjk3NC0xNS4xNTctNS45MDYtMjEuODU2Yy0zLjkzNC02LjY5OS05LjI1LTEyLjAzLTE1Ljk1Ny0xNS45NTYNCglDNjkuMzcyLDEyLjQ1NSw2Mi4wODIsMTAuNDk2LDU0LjIxNiwxMC40OTZ6IE04NC44MTcsMzguOTA4YzAuNTgzLDAuNTksMC44NzEsMS4yMzksMC44NzEsMS45NzRjMCwwLjcyLTAuMjg4LDEuMzExLTAuODcxLDEuNzQzDQoJTDQ3LjIyMSw4MC4wMTNjLTAuNTg0LDAuNTc2LTEuMjQ2LDAuODcxLTEuOTc0LDAuODcxcy0xLjMxMi0wLjI5NS0xLjc1MS0wLjg3MWwtMTkuODktMTkuODk3Yy0wLjU4My0wLjU3Ni0wLjg3MS0xLjIzOS0wLjg3MS0xLjk2Ng0KCXMwLjI4OC0xLjMxMSwwLjg3MS0xLjc1bDUuMDI4LTUuMDI4YzAuNDM5LTAuNDM5LDEuMDE2LTAuNjU2LDEuNzUxLTAuNjU2YzAuNzI4LDAsMS4zODMsMC4yMTYsMS45NjYsMC42NTZsMTIuODk2LDEzLjM0MQ0KCWwzMS4wNDEtMzAuODI1YzAuNDM5LTAuNDM5LDEuMDIyLTAuNjU2LDEuNzUtMC42NTZzMS4zODMsMC4yODgsMS45NjcsMC44NzJMODQuODE3LDM4LjkwOHoiLz4NCjwvc3ZnPg0K"

/***/ })

});


// WEBPACK FOOTER //
// component---src-recipes-recipe-page-js-151340f19cf81ff9507b.js